import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue'
import { subtotalStore } from '@/stores/v2/subtotal'
import { headerStore } from '@/stores/header'


export default /*#__PURE__*/_defineComponent({
  __name: 'WoononSubtotalMobileWidget',
  setup(__props) {

const showModal = ref(false)

onMounted(() => {
  subtotalStore().getSubtotals()
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_button, {
      type: "primary",
      class: "subtotal-mobile-widget",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = true))
    }, {
      default: _withCtx(() => [
        _createTextVNode("Subtotalen")
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      title: "Subtotalen",
      footer: null,
      visible: showModal.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((showModal).value = $event))
    }, {
      default: _withCtx(() => [
        (!_unref(subtotalStore)().loading && _unref(subtotalStore)().subtotals)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_a_row, { class: "no-mb" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 16,
                    class: "price-label"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Modulaire opties:")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 8,
                    class: "price"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(subtotalStore)().subtotals.modular.subtotal_text), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { class: "no-mb" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 16,
                    class: "price-label"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Ruwbouw opties:")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 8,
                    class: "price"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(subtotalStore)().subtotals.carcass.subtotal_text), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { class: "no-mb" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 16,
                    class: "price-label"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Afbouw 1 opties:")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 8,
                    class: "price"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(subtotalStore)().subtotals.completion1.subtotal_text), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { class: "no-mb" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 16,
                    class: "price-label"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Afbouw 2 opties:")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 8,
                    class: "price"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(subtotalStore)().subtotals.completion2.subtotal_text), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { class: "no-mb" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 16,
                    class: "price-label"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Afbouw 3 opties:")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 8,
                    class: "price"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(subtotalStore)().subtotals.completion3.subtotal_text), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_unref(headerStore)().extraPhaseEnabled)
                ? (_openBlock(), _createBlock(_component_a_row, {
                    key: 0,
                    class: "no-mb"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        span: 16,
                        class: "price-label"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Extra opties:")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 8,
                        class: "price"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(subtotalStore)().subtotals.extra.subtotal_text), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_a_divider),
              _createVNode(_component_a_row, { class: "no-mb" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 16,
                    class: "price-label"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Woningprijs:")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 8,
                    class: "price"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(subtotalStore)().subtotals.building.subtotal_text), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 16,
                    class: "price-label"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Meer- en minderwerk:")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 8,
                    class: "price"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(subtotalStore)().subtotals.all_phases.subtotal_text), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_divider),
                  _createVNode(_component_a_col, {
                    span: 16,
                    class: "price-label"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Totaal:")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 8,
                    class: "price"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(subtotalStore)().subtotals.total_text), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ], 64))
          : (_openBlock(), _createBlock(_component_a_skeleton, {
              key: 1,
              active: ""
            }))
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})